import s from './CardSection.module.scss';

type Props = {
  title: string;
  /** Счётчик рядом с заголовком, как у вкладок Яндекс Трекера: «Комментарии 3» */
  count?: number;
  children: React.ReactNode;
};

/** Раздел основной колонки карточки: описание, подзадачи, комментарии */
const CardSection: React.FC<Props> = ({ title, count, children }) => (
  <section className={s.section}>
    <h3 className={s.section__title}>
      {title}
      {count !== undefined && <span className={s.section__count}>{count}</span>}
    </h3>
    {children}
  </section>
);

export { CardSection };
